export function isMutedElement( element: HTMLElement ): element is MutedElement {
	return ( 'muted' in element ) &&
		( 'addEventListener' in element );
}

export type MutedElement = HTMLElement & {
	muted: boolean;
};
